import React, { createContext, useContext } from "react";
import { Keypair } from "@solana/web3.js";
import { UnlinkSDK } from "@unlink/js-sdk";

const UnlinkContext = createContext(null);

let memoryStore = []; // Replace with actual storage later

const sdk = new UnlinkSDK({
  rpcUrl: "https://mainnet.helius-rpc.com/?api-key=b479ed62-ae22-4800-8519-dd6881a5a6bb",
  payer: Keypair.generate(),
  fragmentAdapter: {
    async loadFragments() {
      return memoryStore;
    },
    async storeFragments(fragments) {
      memoryStore = fragments;
    },
  },
});

export const UnlinkProvider = ({ children }) => (
  <UnlinkContext.Provider value={sdk}>{children}</UnlinkContext.Provider>
);

export const useUnlink = () => {
  const ctx = useContext(UnlinkContext);
  if (!ctx) throw new Error("useUnlink must be used within UnlinkProvider");
  return ctx;
};